module.exports = __webpack_public_path__ + "69236a7dd479d6d9b01d709ea341faa6.MP3";